import { useSelector } from 'react-redux';
import { Button } from 'app/pages/request-single-page/components-v4';
import { getOnPostMetersReadingsState } from 'app/pages/request-single-page/selectors';
import { ButtonsWrapper } from './modal-footer.styled';

type ModalFooterProps = {
  onSend: () => void;
  onClose: () => void;
};

export const ModalFooter = ({ onSend, onClose }: ModalFooterProps) => {
  const pending = useSelector(getOnPostMetersReadingsState);

  return (
    <ButtonsWrapper>
      <Button
        size="l"
        mode="neutral"
        variant="main"
        style={{ width: '100%' }}
        onClick={onClose}
      >
        Отмена
      </Button>

      <Button
        type="submit"
        size="l"
        mode="accent"
        variant="main"
        style={{ width: '100%' }}
        onClick={onSend}
        pending={pending}
      >
        Передать показания
      </Button>
    </ButtonsWrapper>
  );
};
